import React from 'react';
import Main from './Component/Main';
import Footer from './Component/Footer';
import './styles.css';

const App = () => {
  return (
    <div className='app'>
        <Main/>
        <Footer/>
    </div>
  )
}

export default App